import React, { useState, useMemo } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import SideMenu from '../navbar/SideMenu';
import SideMenuBuhumuza from '../navbar/SideMenuBuhumuza'; 
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  TextField,
  List, 
  ListItem, 
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  styled,
  useMediaQuery,
  Collapse,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Card,
  CardContent,
  Chip,
  LinearProgress,
  Stack
} from '@mui/material';

import {
  ExpandLess,
  Search,
  Menu as MenuIcon,
  ExpandMore,
  LocationOn,
  TrendingUp,
  TrendingDown,
  Group
} from '@mui/icons-material';

const drawerWidth = 240;
const rightDrawerWidth = 280; 
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const RightDrawerWrapper = styled('div')(({ theme }) => ({
  width: rightDrawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    right: 0,
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(100%)',
    },
  }
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const ProvinceRow = styled(TableRow)({
  backgroundColor: '#e0e0e0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#d0d0d0 !important'
  }
});

const CommuneRow = styled(TableRow)({
  backgroundColor: '#f0f0f0',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#e8e8e8 !important'
  }
});

const ZoneRow = styled(TableRow)({
  backgroundColor: '#f8f8f8',
  fontWeight: 'bold',
  '&:hover': {
    backgroundColor: '#e8e8e8 !important'
  }
});

const populationData = {
  title: "RÉPARTITION DE LA POPULATION DES MÉNAGES ORDINAIRES PAR COLLINE, ZONE ET COMMUNE",
  provinces: [
    {
      id: "1",
      name: "BUHUMUZA",
      communes: [
        {
          id: "104",
          name: "GISAGARA",
          total: 292426,
          zones: [
            {
              id: "10401",
              name: "BUMBA",
              total: 43497,
              collines: [
                { id: "10401103", name: "BUNYERERE", population: 11180 },
                { id: "10401104", name: "MUKA", population: 13089 },
                { id: "10401106", name: "BUMBA", population: 9062 },
                { id: "10401107", name: "RUSIGABANGAZI", population: 5561 },
                { id: "10401102", name: "NYAMWIYANIKE", population: 2707 },
                { id: "10401105", name: "NKORO", population: 1122 },
                { id: "10401101", name: "BUDEGA", population: 776 }
              ]
            },
            {
              id: "10402",
              name: "CAMAZI",
              total: 35221,
              collines: [
                { id: "10402101", name: "CAMAZI", population: 10470 },
                { id: "10402103", name: "MBURI", population: 8568 },
                { id: "10402104", name: "MUZIRE", population: 5909 },
                { id: "10402106", name: "RURAMBA", population: 4730 },
                { id: "10402102", name: "GISOKO", population: 4279 },
                { id: "10402105", name: "RABIRO", population: 1265 }
              ]
            },
            {
              id: "10403",
              name: "CENDAJURU",
              total: 13407,
              collines: [
                { id: "10403107", name: "GAHOKO", population: 1626 },
                { id: "10403103", name: "KIBANDE", population: 3130 },
                { id: "10403105", name: "KIRUHURA", population: 3116 },
                { id: "10403104", name: "KIGARIKA", population: 1527 },
                { id: "10403101", name: "CENDAJURU", population: 2379 },
                { id: "10403106", name: "KIYANGE", population: 728 },
                { id: "10403102", name: "KABAGENI", population: 901 }
              ]
            },
            {
              id: "10404",
              name: "GISAGARA",
              total: 36779,
              collines: [
                { id: "10404114", name: "MURAGO", population: 4953 },
                { id: "10404104", name: "GITWENGE", population: 3830 },
                { id: "10404106", name: "KIBOGOYE", population: 3887 },
                { id: "10404111", name: "NYURO", population: 3300 },
                { id: "10404109", name: "MUGANZA", population: 3011 },
                { id: "10404107", name: "KIGATI", population: 3112 },
                { id: "10404112", name: "RAMBA", population: 2987 },
                { id: "10404103", name: "GITANGA", population: 1667 },
                { id: "10404102", name: "GISAGARA", population: 2208 },
                { id: "10404110", name: "MUHINGAMO", population: 2033 },
                { id: "10404101", name: "GERERO", population: 1852 },
                { id: "10404113", name: "RUBABARA", population: 1196 },
                { id: "10404108", name: "KIRAMBI", population: 852 },
                { id: "10404105", name: "KAGOMA", population: 1891 }
              ]
            },
            {
              id: "10405",
              name: "MUGERA",
              total: 26342,
              collines: [
                { id: "10405103", name: "MUGERA", population: 10954 },
                { id: "10405102", name: "KANIHA", population: 7361 },
                { id: "10405101", name: "BUSUMANYI", population: 5080 },
                { id: "10405104", name: "MUSEMO", population: 2947 }
              ]
            },
            {
              id: "10406",
              name: "MISHIHA",
              total: 52124,
              collines: [
                { id: "10406103", name: "MISHIHA", population: 23695 },
                { id: "10406105", name: "RUTSINDU", population: 10168 },
                { id: "10406104", name: "MUNZENZE", population: 9438 },
                { id: "10406102", name: "GIKONKO", population: 6886 },
                { id: "10406101", name: "BUYONGWE", population: 1937 }
              ]
            },
            {
              id: "10407",
              name: "MWIRUZI",
              total: 42089,
              collines: [
                { id: "10407101", name: "KIBIMBA", population: 11774 },
                { id: "10407102", name: "MWIRUZI", population: 11967 },
                { id: "10407105", name: "RUNIHIRA", population: 8315 },
                { id: "10407104", name: "RUKWEGA", population: 7586 },
                { id: "10407103", name: "RUGERERO", population: 2447 }
              ]
            },
            {
              id: "10408",
              name: "NYAMUGARI",
              total: 17853,
              collines: [
                { id: "10408105", name: "RUKOYOYO", population: 6437 },
                { id: "10408104", name: "NYAMUGARI", population: 4201 },
                { id: "10408102", name: "GASHIGWE", population: 3110 },
                { id: "10408101", name: "BUSYANA", population: 2163 },
                { id: "10408103", name: "GITARAMUKA", population: 1942 }
              ]
            },
            {
              id: "10409",
              name: "TWINKWAVU",
              total: 25114,
              collines: [
                { id: "10409105", name: "TWINKWAVU", population: 9151 },
                { id: "10409102", name: "MISUGI", population: 7073 },
                { id: "10409101", name: "GISORO", population: 4063 },
                { id: "10409103", name: "NYAGISOVU", population: 2803 },
                { id: "10409104", name: "NYAKUGUMA", population: 2024 }
              ]
            }
          ]
        }
      ]
    }
  ]
};

const PopulationDataPageBuhumuzaGisagara = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileRightOpen, setMobileRightOpen] = useState(false);
  const [expandedProvinces, setExpandedProvinces] = useState({});
  const [expandedCommunes, setExpandedCommunes] = useState({});
  const [expandedZones, setExpandedZones] = useState({});
  const [openKeyStats, setOpenKeyStats] = useState(true);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleRightDrawerToggle = () => {
    setMobileRightOpen(!mobileRightOpen);
  };

  const toggleProvince = (provinceId) => {
    setExpandedProvinces(prev => ({
      ...prev,
      [provinceId]: !prev[provinceId]
    }));
  };

  const toggleCommune = (communeId) => {
    setExpandedCommunes(prev => ({
      ...prev,
      [communeId]: !prev[communeId]
    }));
  };

  const toggleZone = (zoneId) => {
    setExpandedZones(prev => ({
      ...prev,
      [zoneId]: !prev[zoneId]
    }));
  };

  const filterData = (data, searchTerm) => {
    if (!searchTerm) return data;
    
    const filteredProvinces = data.provinces.map(province => {
      const filteredCommunes = province.communes.filter(commune => {
        const filteredZones = commune.zones.filter(zone => {
          const filteredCollines = zone.collines.filter(colline =>
            colline.name.toLowerCase().includes(searchTerm.toLowerCase())
          );
          
          return filteredCollines.length > 0 || 
                 zone.name.toLowerCase().includes(searchTerm.toLowerCase());
        });
        
        return filteredZones.length > 0 || 
               commune.name.toLowerCase().includes(searchTerm.toLowerCase());
      });
      
      return {
        ...province,
        communes: filteredCommunes,
        show: filteredCommunes.length > 0 || 
              province.name.toLowerCase().includes(searchTerm.toLowerCase())
      };
    }).filter(province => province.show || !searchTerm);
    
    return {
      ...data,
      provinces: filteredProvinces
    };
  };

  const filteredData = filterData(populationData, searchTerm);

  const keyStats = useMemo(() => {
    const province = populationData.provinces[0];
    const commune = province.communes[0];
    
    const mostPopulatedZone = commune.zones.reduce((max, zone) => 
      zone.total > max.total ? zone : max, commune.zones[0]);
    
    const leastPopulatedZone = commune.zones.reduce((min, zone) => 
      zone.total < min.total ? zone : min, commune.zones[0]);
    
    const mostPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((max, colline) => colline.population > max.population ? colline : max, {population: 0});
    
    const leastPopulatedColline = commune.zones.flatMap(zone => zone.collines)
      .reduce((min, colline) => colline.population < min.population ? colline : min, {population: Infinity});

    const zonePercentages = commune.zones.map(zone => ({
      ...zone,
      percentage: ((zone.total / commune.total) * 100).toFixed(1)
    }));
    
    return {
      totalPopulation: commune.total.toLocaleString(),
      totalZones: commune.zones.length,
      totalCollines: commune.zones.reduce((sum, zone) => sum + zone.collines.length, 0),
      mostPopulatedZone,
      leastPopulatedZone,
      mostPopulatedColline,
      leastPopulatedColline,
      zonePercentages,
      communeTotal: commune.total
    };
  }, []);

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            <SideMenu /> 
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            <SideMenu />
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
                <Button 
                  variant="outlined" 
                  endIcon={<MenuIcon />} 
                  onClick={handleRightDrawerToggle}
                  sx={{ color: secondaryColor, borderColor: secondaryColor }}
                >
                  Info Buhumuza
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="body1" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {populationData.title}
                    </Typography>
                    <Chip 
                      icon={<Group />} 
                      label={`Commune de GISAGARA`} 
                      color="primary" 
                      variant="outlined" 
                    />
                  </Box>
                  
                  <Grid container spacing={1} style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6}></Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher zone/colline..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '400px' } }}
                      />
                    </Grid>
                  </Grid>
                
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                         Commune de GISAGARA
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Population Totale
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="primary">
                                {keyStats.totalPopulation}
                              </Typography>
                              <Typography variant="caption">
                                Habitants
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Zones
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="secondary">
                                {keyStats.totalZones}
                              </Typography>
                              <Typography variant="caption">
                                Zones répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                                Nombre de Collines
                              </Typography>
                              <Typography variant="h4" fontWeight="bold" color="primary">
                                {keyStats.totalCollines}
                              </Typography>
                              <Typography variant="caption">
                                Collines répertoriées
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.mostPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.mostPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Zone la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedZone.name}
                              </Typography>
                              <Stack direction="row" spacing={1} alignItems="baseline">
                                <Typography variant="body1">
                                  {keyStats.leastPopulatedZone.total.toLocaleString()}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                  ({((keyStats.leastPopulatedZone.total / keyStats.communeTotal) * 100).toFixed(1)}%)
                                </Typography>
                              </Stack>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingUp fontSize="small" color="success" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la plus peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.mostPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.mostPopulatedColline.population?.toLocaleString() || '0'}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                                <TrendingDown fontSize="small" color="error" />
                                <Typography variant="subtitle2" color="text.secondary">
                                  Colline la moins peuplée
                                </Typography>
                              </Stack>
                              <Typography variant="h6" fontWeight="bold">
                                {keyStats.leastPopulatedColline.name}
                              </Typography>
                              <Typography variant="body1">
                                {keyStats.leastPopulatedColline.population?.toLocaleString() || '0'}
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>

                      <Box sx={{ mt: 3 }}>
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
                          Répartition de la population par zone
                        </Typography>
                        {keyStats.zonePercentages.map((zone) => (
                          <Box key={zone.id} sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                              <Typography variant="body2">
                                {zone.name}
                              </Typography>
                              <Typography variant="body2" fontWeight="bold">
                                {zone.percentage}% ({zone.total.toLocaleString()})
                              </Typography>
                            </Box>
                            <LinearProgress 
                              variant="determinate" 
                              value={zone.percentage} 
                              sx={{ 
                                height: 8, 
                                borderRadius: 4,
                                backgroundColor: '#e0e0e0',
                                '& .MuiLinearProgress-bar': {
                                  backgroundColor: zone.id === keyStats.mostPopulatedZone.id ? primaryColor : 
                                                zone.id === keyStats.leastPopulatedZone.id ? secondaryColor : '#888',
                                }
                              }} 
                            />
                          </Box>
                        ))}
                      </Box>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau des données démographiques">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell>Province/Commune/Zone/Colline</TableCell>
                          <TableCell align="right">Population</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {filteredData.provinces.map((province) => (
                          <React.Fragment key={province.id}>
                            <ProvinceRow 
                              hover 
                              onClick={() => toggleProvince(province.id)}
                              sx={{ cursor: 'pointer' }}
                            >
                              <TableCell component="th" scope="row" colSpan={2}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                  {expandedProvinces[province.id] ? <ExpandLess /> : <ExpandMore />}
                                  <LocationOn sx={{ mr: 1, color: primaryColor }} />
                                  {province.name}
                                </Box>
                              </TableCell>
                            </ProvinceRow>
                            
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={2}>
                                <Collapse in={expandedProvinces[province.id] || !!searchTerm} timeout="auto" unmountOnExit>
                                  <Table size="small" sx={{ backgroundColor: '#fafafa' }}>
                                    <TableBody>
                                      {province.communes.map((commune) => (
                                        <React.Fragment key={commune.id}>
                                          <CommuneRow 
                                            hover 
                                            onClick={() => toggleCommune(commune.id)}
                                            sx={{ cursor: 'pointer' }}
                                          >
                                            <TableCell sx={{ pl: 4 }}>
                                              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                {expandedCommunes[commune.id] ? <ExpandLess /> : <ExpandMore />}
                                                <LocationOn sx={{ mr: 1, color: secondaryColor, fontSize: '18px' }} />
                                                {commune.name}
                                              </Box>
                                            </TableCell>
                                            <TableCell align="right">{commune.total.toLocaleString()}</TableCell>
                                          </CommuneRow>
                                          
                                          <TableRow>
                                            <TableCell style={{ padding: 0 }} colSpan={2}>
                                              <Collapse in={expandedCommunes[commune.id] || !!searchTerm} timeout="auto" unmountOnExit>
                                                <Table size="small" sx={{ backgroundColor: '#f5f5f5' }}>
                                                  <TableBody>
                                                    {commune.zones.map((zone) => (
                                                      <React.Fragment key={zone.id}>
                                                        <ZoneRow 
                                                          hover 
                                                          onClick={() => toggleZone(zone.id)}
                                                          sx={{ cursor: 'pointer' }}
                                                        >
                                                          <TableCell sx={{ pl: 8 }}>
                                                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                                              {expandedZones[zone.id] ? <ExpandLess /> : <ExpandMore />}
                                                              <LocationOn sx={{ mr: 1, color: '#666', fontSize: '16px' }} />
                                                              {zone.name}
                                                            </Box>
                                                          </TableCell>
                                                          <TableCell align="right">{zone.total.toLocaleString()}</TableCell>
                                                        </ZoneRow>
                                                        
                                                        <TableRow>
                                                          <TableCell style={{ padding: 0 }} colSpan={2}>
                                                            <Collapse in={expandedZones[zone.id] || !!searchTerm} timeout="auto" unmountOnExit>
                                                              <Table size="small">
                                                                <TableBody>
                                                                  {zone.collines.map((colline) => (
                                                                    <TableRow key={colline.id} hover>
                                                                      <TableCell sx={{ pl: 12 }}>{colline.name}</TableCell>
                                                                      <TableCell align="right">{colline.population.toLocaleString()}</TableCell>
                                                                    </TableRow>
                                                                  ))}
                                                                </TableBody>
                                                              </Table>
                                                            </Collapse>
                                                          </TableCell>
                                                        </TableRow>
                                                      </React.Fragment>
                                                    ))}
                                                  </TableBody>
                                                </Table>
                                              </Collapse>
                                            </TableCell>
                                          </TableRow>
                                        </React.Fragment>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>

                </Paper>
                
                <Accordion sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      Structure administrative - Commune de GISAGARA
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Typography variant="body2" paragraph>
                      La commune de GISAGARA est divisée en {keyStats.totalZones} zones administratives:
                    </Typography>
                    <List dense sx={{ py: 0 }}>
                      {keyStats.zonePercentages.map((zone, index) => (
                        <ListItem key={zone.id}>
                          <ListItemText 
                            primary={`${index + 1}. ${zone.name}`} 
                            secondary={`Population: ${zone.total.toLocaleString()} habitants (${zone.percentage}%) - ${zone.collines.length} collines`} 
                          />
                        </ListItem>
                      ))}
                    </List>
                  </AccordionDetails>
                </Accordion>
                
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées sont issues du Recensement Général de la Population. 
                    Les chiffres incluent uniquement la population des ménages ordinaires.
                    Les pourcentages sont calculés par rapport à la population totale de la commune de GISAGARA ({keyStats.totalPopulation} habitants).
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>

        {!isMobile ? (
          <RightDrawerWrapper>
            <SideMenuBuhumuza />
          </RightDrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            anchor="right"
            open={mobileRightOpen}
            onClose={handleRightDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: rightDrawerWidth },
            }}
          >
            <SideMenuBuhumuza /> 
          </Drawer>
        )}
      </MainContentWithDrawer>
      <Footer />
    </MainContainer>
  );
};

export default PopulationDataPageBuhumuzaGisagara;